module.exports = __webpack_public_path__ + "static/media/maintenance.9610d7f1.png";